// 需要授权的路由

const order = [
  {
    path: 'payment',
    name: 'payment',
    meta: {
      title: '购买课程',
      type: 'menu',
      auth: true,
      hidden: true
    },
    component: () => import('@/views/pay/payment'),
    children: [{
      path: 'success',
      name: 'paySuccess',
      meta: {
        title: '支付成功',
        type: 'menu',
        auth: true,
        hidden: true
      },
      component: () => import('@/views/pay/success')
    }]
  }
]

export default order
